import React from 'react';

/**
 * BlogPullQuote - Highlighted excerpt from the article itself
 * Different from Blockquote - this is for emphasizing your own content
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Quote content
 */
export const BlogPullQuote = ({ children }) => {
  return (
    <aside 
      className="my-8 py-8 border-y border-[#00E87A]/30 text-center"
      data-testid="blog-pull-quote"
    >
      <p className="text-2xl font-semibold text-white leading-relaxed">
        "{children}"
      </p>
    </aside>
  );
};

export default BlogPullQuote;
